import type { KeyOption } from "@/types/defs/keyOption";

export const keyOptions = (ko?: KeyOption): KeyOption[] => [
  ...(ko !== undefined ? [ko] : []),
  "No Key",
  "C Maj",
  "C Min",
  "C# Maj",
  "C# Min",
  "D Maj",
  "D Min",
  "D# Maj",
  "D# Min",
  "E Maj",
  "E Min",
  "F Maj",
  "F Min",
  "F# Maj",
  "F# Min",
  "G Maj",
  "G Min",
  "G# Maj",
  "G# Min",
  "A Maj",
  "A Min",
  "A# Maj",
  "A# Min",
  "B Maj",
  "B Min",
];
